import type { SubmissionStatus } from '@/services/types';

export function isSubmissionPending(status: SubmissionStatus) {
  return status === 'QUEUED' || status === 'PENDING' || status === 'RUNNING';
}

export function submissionStatusLabel(status: SubmissionStatus) {
  switch (status) {
    case 'QUEUED':
      return '排队中';
    case 'PENDING':
      return '等待判题';
    case 'RUNNING':
      return '判题中';
    case 'ACCEPTED':
      return '通过';
    case 'WRONG_ANSWER':
      return '答案错误';
    case 'TIME_LIMIT_EXCEEDED':
      return '超时';
    case 'MEMORY_LIMIT_EXCEEDED':
      return '内存超限';
    case 'RUNTIME_ERROR':
      return '运行错误';
    case 'COMPILE_ERROR':
      return '编译错误';
    default:
      return status;
  }
}

export function submissionStatusTone(status: SubmissionStatus) {
  switch (status) {
    case 'ACCEPTED':
      return 'success';
    case 'QUEUED':
    case 'PENDING':
    case 'RUNNING':
      return 'processing';
    default:
      return 'failure';
  }
}

export function formatPassRatio(value: number) {
  if (!Number.isFinite(value)) {
    return '0%';
  }

  const percentage = Math.round(Math.max(0, Math.min(1, value)) * 100);
  return `${percentage}%`;
}
